import { apiZoho } from '#plugins/axios.js';

export const getOrdersByClientId = async (clientId) => {
  const response = await apiZoho.get('Ordenes_1hora_Admin_Report', {
    params: {
      where: `Clientes.Documento=="${clientId}"`,
    },
  });
  return response.data.data;
};
